//SMM Social Media Management Action Types
///socialmediapostchannelstatus/list
export const FETCH_SMM_POST_CHANNEL_STATUS_LIST =
  "FETCH_SMM_POST_CHANNEL_STATUS_LIST";
export const FETCH_SMM_POST_CHANNEL_STATUS_LIST_SUCCESS =
  "FETCH_SMM_POST_CHANNEL_STATUS_LIST_SUCCESS";
export const FETCH_SMM_POST_CHANNEL_STATUS_LIST_FAILURE =
  "FETCH_SMM_POST_CHANNEL_STATUS_LIST_FAILURE";
///socialmediapostchannelstatus/data
export const FETCH_SMM_POST_CHANNEL_STATUS_DATA =
  "FETCH_SMM_POST_CHANNEL_STATUS_DATA";
export const FETCH_SMM_POST_CHANNEL_STATUS_DATA_SUCCESS =
  "FETCH_SMM_POST_CHANNEL_STATUS_DATA_SUCCESS";
export const FETCH_SMM_POST_CHANNEL_STATUS_DATA_FAILURE =
  "FETCH_SMM_POST_CHANNEL_STATUS_DATA_FAILURE";
///socialmediapostchannelstatus/create
export const CREATE_SMM_POST_CHANNEL_STATUS = "CREATE_SMM_POST_CHANNEL_STATUS";
export const CREATE_SMM_POST_CHANNEL_STATUS_SUCCESS =
  "CREATE_SMM_POST_CHANNEL_STATUS_SUCCESS";
export const CREATE_SMM_POST_CHANNEL_STATUS_FAILURE =
  "CREATE_SMM_POST_CHANNEL_STATUS_FAILURE";
///socialmediapostchannelstatus/update
export const UPDATE_SMM_POST_CHANNEL_STATUS = "UPDATE_SMM_POST_CHANNEL_STATUS";
export const UPDATE_SMM_POST_CHANNEL_STATUS_SUCCESS =
  "UPDATE_SMM_POST_CHANNEL_STATUS_SUCCESS";
export const UPDATE_SMM_POST_CHANNEL_STATUS_FAILURE =
  "UPDATE_SMM_POST_CHANNEL_STATUS_FAILURE";
///socialmediapostchannelstatus/delete
export const DELETE_SMM_POST_CHANNEL_STATUS = "DELETE_SMM_POST_CHANNEL_STATUS";
export const DELETE_SMM_POST_CHANNEL_STATUS_SUCCESS =
  "DELETE_SMM_POST_CHANNEL_STATUS_SUCCESS";
export const DELETE_SMM_POST_CHANNEL_STATUS_FAILURE =
  "DELETE_SMM_POST_CHANNEL_STATUS_FAILURE";
///socialmediapost/list
export const FETCH_SMM_POST_LIST = "FETCH_SMM_POST_LIST";
export const FETCH_SMM_POST_LIST_SUCCESS = "FETCH_SMM_POST_LIST_SUCCESS";
export const FETCH_SMM_POST_LIST_FAILURE = "FETCH_SMM_POST_LIST_FAILURE";
///socialmediapost/data
export const FETCH_SMM_POST_DATA = "FETCH_SMM_POST_DATA";
export const FETCH_SMM_POST_DATA_SUCCESS = "FETCH_SMM_POST_DATA_SUCCESS";
export const FETCH_SMM_POST_DATA_FAILURE = "FETCH_SMM_POST_DATA_FAILURE";
///socialmediapost/create
export const CREATE_SMM_POST = "CREATE_SMM_POST";
export const CREATE_SMM_POST_SUCCESS = "CREATE_SMM_POST_SUCCESS";
export const CREATE_SMM_POST_FAILURE = "CREATE_SMM_POST_FAILURE";
///socialmediapost/update
export const UPDATE_SMM_POST = "UPDATE_SMM_POST";
export const UPDATE_SMM_POST_SUCCESS = "UPDATE_SMM_POST_SUCCESS";
export const UPDATE_SMM_POST_FAILURE = "UPDATE_SMM_POST_FAILURE";
///socialmediapost/delete
export const DELETE_SMM_POST = "DELETE_SMM_POST";
export const DELETE_SMM_POST_SUCCESS = "DELETE_SMM_POST_SUCCESS";
export const DELETE_SMM_POST_FAILURE = "DELETE_SMM_POST_FAILURE";
///socialmediaconnect/*  (Task 24873)
export const SOCIAL_MEDIA_CONNECT_START = "SOCIAL_MEDIA_CONNECT_START";
export const SOCIAL_MEDIA_CONNECT_START_SUCCESS =
  "SOCIAL_MEDIA_CONNECT_START_SUCCESS";
export const SOCIAL_MEDIA_CONNECT_START_FAILURE =
  "SOCIAL_MEDIA_CONNECT_START_FAILURE";
export const SOCIAL_MEDIA_CONNECT_COMPLETE = "SOCIAL_MEDIA_CONNECT_COMPLETE";
export const SOCIAL_MEDIA_CONNECT_COMPLETE_SUCCESS =
  "SOCIAL_MEDIA_CONNECT_COMPLETE_SUCCESS";
export const SOCIAL_MEDIA_CONNECT_COMPLETE_FAILURE =
  "SOCIAL_MEDIA_CONNECT_COMPLETE_FAILURE";
export const SOCIAL_MEDIA_CONNECT_ASSIGN = "SOCIAL_MEDIA_CONNECT_ASSIGN";
export const SOCIAL_MEDIA_CONNECT_ASSIGN_SUCCESS =
  "SOCIAL_MEDIA_CONNECT_ASSIGN_SUCCESS";
export const SOCIAL_MEDIA_CONNECT_ASSIGN_FAILURE =
  "SOCIAL_MEDIA_CONNECT_ASSIGN_FAILURE";
export const SOCIAL_MEDIA_CONNECT_DISCONNECT =
  "SOCIAL_MEDIA_CONNECT_DISCONNECT";
export const SOCIAL_MEDIA_CONNECT_DISCONNECT_SUCCESS =
  "SOCIAL_MEDIA_CONNECT_DISCONNECT_SUCCESS";
export const SOCIAL_MEDIA_CONNECT_DISCONNECT_FAILURE =
  "SOCIAL_MEDIA_CONNECT_DISCONNECT_FAILURE";

///mastersocialmediaprovider/list
export const FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST =
  "FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST";
export const FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_SUCCESS =
  "FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_SUCCESS";
export const FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_FAILURE =
  "FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST_FAILURE";
///mastersocialmediaprovider/data
export const FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA =
  "FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA";
export const FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_SUCCESS =
  "FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_SUCCESS";
export const FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_FAILURE =
  "FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA_FAILURE";
///mastersocialmediaprovider/create
export const CREATE_MASTER_SOCIAL_MEDIA_PROVIDER =
  "CREATE_MASTER_SOCIAL_MEDIA_PROVIDER";
export const CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS =
  "CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS";
export const CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE =
  "CREATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE";
///mastersocialmediaprovider/update
export const UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER =
  "UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER";
export const UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS =
  "UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS";
export const UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE =
  "UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE";
///mastersocialmediaprovider/delete
export const DELETE_MASTER_SOCIAL_MEDIA_PROVIDER =
  "DELETE_MASTER_SOCIAL_MEDIA_PROVIDER";
export const DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS =
  "DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_SUCCESS";
export const DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE =
  "DELETE_MASTER_SOCIAL_MEDIA_PROVIDER_FAILURE";
///socialmediaprofile/list
export const FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST =
  "FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST";
export const FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_SUCCESS =
  "FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_SUCCESS";
export const FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_FAILURE =
  "FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST_FAILURE";
///socialmediaprofile/data
export const FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA =
  "FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA";
export const FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_SUCCESS =
  "FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_SUCCESS";
export const FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_FAILURE =
  "FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA_FAILURE";
///socialmediaprofile/create
export const CREATE_MASTER_SOCIAL_MEDIA_PROFILE =
  "CREATE_MASTER_SOCIAL_MEDIA_PROFILE";
export const CREATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS =
  "CREATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS";
export const CREATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE =
  "CREATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE";
///socialmediaprofile/update
export const UPDATE_MASTER_SOCIAL_MEDIA_PROFILE =
  "UPDATE_MASTER_SOCIAL_MEDIA_PROFILE";
export const UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS =
  "UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS";
export const UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE =
  "UPDATE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE";
///socialmediaprofile/delete
export const DELETE_MASTER_SOCIAL_MEDIA_PROFILE =
  "DELETE_MASTER_SOCIAL_MEDIA_PROFILE";
export const DELETE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS =
  "DELETE_MASTER_SOCIAL_MEDIA_PROFILE_SUCCESS";
export const DELETE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE =
  "DELETE_MASTER_SOCIAL_MEDIA_PROFILE_FAILURE";
///socialmediapost/generatecontent
export const GENERATE_SMM_POST_CONTENT = "GENERATE_SMM_POST_CONTENT";
export const GENERATE_SMM_POST_CONTENT_SUCCESS =
  "GENERATE_SMM_POST_CONTENT_SUCCESS";
export const GENERATE_SMM_POST_CONTENT_FAILURE =
  "GENERATE_SMM_POST_CONTENT_FAILURE";
///socialmediapost/generateimage
export const GENERATE_SMM_POST_IMAGE = "GENERATE_SMM_POST_IMAGE";
export const GENERATE_SMM_POST_IMAGE_SUCCESS =
  "GENERATE_SMM_POST_IMAGE_SUCCESS";
export const GENERATE_SMM_POST_IMAGE_FAILURE =
  "GENERATE_SMM_POST_IMAGE_FAILURE";

